<template>
    <div class="speaker-profile--wrapper relative-position">
        <status-overlay :action="loadingAction" content-height="500px"></status-overlay>
        <v-layout
            v-if="speakerProfile"
            row
            wrap
            class="speaker-profile">
            <v-flex
                xs12
                sm6
                d-flex
                align-center>
                <a v-if="canViewSpeakerAdminDirectory && !isSpeakerView && !searchResults " class="speaker-profile__back-to" @click="BackToSpeakerDirectory()">
                    <i class="fas fa-arrow-left"></i> {{SpeakerApplicants.SPEAKER_RESOURCE_DIRECTORY_ADMINISTRATION}}
                </a>
                <a v-if="searchResults" class="speaker-profile__back-to" @click="BackToSpeakerDirectory()">
                    <i class="fas fa-arrow-left"></i> {{checkCFF ? SpeakerApplicants.BACK_TO_CFF_DIRECTORY : SpeakerApplicants.BACK_TO_SPEAKER_DIRECTORY}}
                </a>
            </v-flex>
            <v-flex
                xs12
                sm6
                text-xs-right
                v-if="canEditSpeakerProfile">
                <span class="speaker-profile__edit-profile-btn">
                    <v-btn class="primary_btn small" @click="openEditProfile(speakerProfile)">
                        {{SpeakerApplicants.EDIT_PROFILE}}
                    </v-btn>
                </span>
            </v-flex>
            <v-layout
                row
                wrap
                class="member-info">
                <v-flex xs12 md8>
                    <v-layout class="member-info__details">
                        <v-flex class="profile">
                            <figure>
                                <v-img
                                    data-qe-id="speaker-profile_profile-image"
                                    contain
                                    :src="speakerProfile.profileImageUrl === null ? speakerProfile.fallbackProfileImageUrl : speakerProfile.profileImageUrl "
                                    @error="imageErrorFallback(speakerProfile)"></v-img>
                                <small v-if="speakerProfile && speakerProfile.recordTypeName && !speakerProfile.recordTypeName.toLowerCase().includes('speaker')">{{speakerProfile.recordTypeName}}</small>
                            </figure>

                            <span v-if="viewMySpeakerProfile(speakerProfile.speakerType)" @click="openMemberProfile(speakerProfile.personId)">{{speakerConstants.VIEW_MY_YPO_PROFILE}}</span>
                        </v-flex>
                        <v-flex class="summary">
                            <strong data-qe-id="speaker-profile_name">{{speakerProfile.preferredName ? speakerProfile.preferredName : speakerProfile.firstName}} {{speakerProfile.familyName}}</strong>

                            <small data-qe-id="speaker-profile_ismember">{{speakerProfile.title}} <span v-if="speakerProfile.primaryChapter && speakerProfile.title"> | </span> {{speakerProfile.primaryChapter}}</small>
                            <v-flex
                                tag="label"
                                class="label-cff"
                                v-if="speakerProfile.isCFF">{{speakerConstants.CFF}}</v-flex>
                            <v-flex class="summary__fee">
                                <strong data-qe-id="speaker-profile_fee-range">{{`${speakerConstants.FEE_RANGE}`}}: {{speakerProfile.feeRange && speakerProfile.feeRange.feeRange || ''}}</strong>
                                <small mb-1 data-qe-id="speaker-profile_cff_fee-range" v-scroll-to="{ el: '#cff_information_section', offset: -100 }" class="cff_fee" v-if="speakerProfile.isCFF">{{speakerConstants.CFF_FEE}}</small>
                                <span>{{speakerConstants.WILLING_TO_NEGOTIATE_FEES}}: <em data-qe-id="speaker-profile_willing-to-negotiate-fee">{{speakerProfile.reducedFee=== "True" ? speakerConstants.YES : speakerConstants.NO}}</em></span>
                                <span class="pt-3">{{speakerConstants.TRAVELS_FROM}}: <em data-qe-id="speaker-profile_travels-from">{{speakerProfile.travelFromCity}}, {{speakerProfile.country}}</em></span>
                                <span class="d-inline-block">{{speakerConstants.SPOKEN_AT_YPO_EVENTS}}: <em data-qe-id="speaker-profile_spoken-at-Ypo-events">{{speakerProfile.previuoslySpokenAtYpoEvent ? speakerConstants.YES : speakerConstants.NO}}</em> </span> <span @click="openMoreInfo()" class="d-inline-block"><i class="fas fa-info-circle"></i> </span>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        row
                        wrap
                        mt-5
                        class="member-info__more-info">
                        <v-flex xs12 class="links">
                            <a v-scroll-to="{ el: '#about_section', offset: -100 }">{{speakerConstants.ABOUT_ME}}</a>
                            <a v-scroll-to="{ el: '#presentation_section', offset: -100 }" v-if="speakerProfile.presentationUrl" >{{speakerConstants.PRESENTATIONS}}</a>
                            <a data-qe-id="speaker-profile_cff_information" v-scroll-to="{ el: '#cff_information_section', offset: -100 }" v-if="speakerProfile.isCFF">{{speakerConstants.CFF_INFORMATION_FEES}}</a>
                            <a v-scroll-to="{ el: '#known_languages_section', offset: -100 }">{{speakerConstants.LANGUAGES_SPOKEN}}
                                <!-- <span v-if="spokenLanguagesCount > 1"> + {{spokenLanguagesCount}} </span> -->
                            </a>
                            <a v-scroll-to="{ el: '#referrals_section', offset: -100 }">{{speakerConstants.REFERRALS}}</a>
                        </v-flex>
                        <v-divider></v-divider>
                        <v-flex
                            xs12
                            class="forum-facilitator"
                            v-if="speakerProfile.isCFF">
                            <v-layout
                                row
                                wrap
                                class="forum-facilitator__title">
                                <v-flex xs12 sm9><span id="cff_information_section">{{speakerConstants.CERTIFIED_FORUM_FACILITATOR}}</span></v-flex>
                                <v-flex
                                    xs12
                                    sm3
                                    text-xs-left
                                    text-sm-center
                                    class="since"><span>{{speakerConstants.SINCE}} {{speakerProfile.cffSince}} </span></v-flex>
                            </v-layout>
                            <v-flex class="forum-facilitator__body">
                                <v-flex class="regions">
                                    <span v-if="speakerProfile.cffRegion"><strong>{{speakerConstants.REGIONS}} </strong><small>{{speakerProfile.cffRegion.name}}</small></span>
                                    <strong v-if="speakerProfile.tagLine">{{speakerConstants.TAG_LINE}} {{speakerProfile.tagLine}}</strong>
                                    <v-flex class="regions__rating" v-if="speakerProfile.averageCffRating && speakerProfile.averageCffRating != '0'">
                                        <span>{{speakerConstants.CFF_RATING}}</span>
                                        <strong>{{speakerProfile.averageCffRating}}</strong>
                                    </v-flex>
                                </v-flex>
                                <v-flex
                                    xs12
                                    sm8
                                    mt-3
                                    class="fees-daily-rate"
                                    v-if="speakerProfile.cffFee && speakerProfile.cffFee.length > 0">
                                    <v-layout
                                        row
                                        wrap
                                        class="fees-daily-rate__header">
                                        <v-flex xs6 tag="strong">{{speakerConstants.CFF_FEES_RATE}}</v-flex>
                                        <v-flex xs3 tag="strong">{{speakerConstants.MINIMUM}}</v-flex>
                                        <v-flex xs3 tag="strong">{{speakerConstants.MAXIMUM}}</v-flex>
                                    </v-layout>
                                    <v-layout
                                        row
                                        wrap
                                        class="fees-daily-rate__row"
                                        v-for="(cffFee, index) in speakerProfile.cffFee"
                                        :key="index">
                                        <v-flex xs6 tag="span">{{cffFee.trainingName}}</v-flex>
                                        <v-flex xs3 tag="span">{{getNumberInFormat(cffFee.minimumFee)}}</v-flex>
                                        <v-flex xs3 tag="span">{{getNumberInFormat(cffFee.maximumFee)}}</v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex
                                    mt-3
                                    class="qualifications"
                                    v-if="speakerProfile.qualification">
                                    <strong>{{speakerConstants.QUALIFICATIONS}}</strong>
                                    <span v-html="speakerProfile.qualification"></span>
                                </v-flex>
                                <v-flex mt-3>
                                    <span v-if="speakerProfile.numberofFourmPrograms"><strong>{{speakerConstants.NUMBER_FORUM_PROGRAM}}</strong> {{speakerConstants.IN_PAST_YEAR}} {{speakerProfile.numberofFourmPrograms}}</span>
                                </v-flex>
                                <v-flex
                                    mt-3
                                    class="retreat-topic"
                                    v-if="speakerProfile.retreatTopic">
                                    <strong>{{speakerConstants.RETREAT_TOPIC}}</strong>
                                    <span v-html="speakerProfile.retreatTopic"></span>
                                </v-flex>
                            </v-flex>
                        </v-flex>
                        <v-flex
                            py-4
                            xs12
                            class="about-me">
                            <strong id="about_section" class="member-info__title">{{speakerConstants.ABOUT_ME}}</strong>
                            <v-flex v-for="(paragraph,index) in biographyParagraphs" :key="index" data-qe-id="speaker-profile_about-me">
                                <p>{{paragraph}}</p>
                            </v-flex>
                            <v-layout row wrap>
                                <v-flex xs12 sm4>
                                    <span>{{speakerConstants.TRAVEL_RESOURCE_PROGRAM}}</span>
                                    <small data-qe-id="speaker-profile_participatesInTravelResourceProgram">{{speakerProfile.travellingResourceProgram ? speakerConstants.SPEAKER_PARTICIPATES : speakerConstants.NO}}</small>
                                </v-flex>
                                <v-flex
                                    xs12
                                    sm8
                                    class="about-me__participates">
                                    <span>{{speakerConstants.SPEAKER_IS_AVAILABLE_TO_SPEAK_ONLINE_OR_VIRTUAL}}</span>
                                    <small data-qe-id="speaker-profile_available-online">{{speakerProfile.servingResource ? speakerConstants.YES : speakerConstants.NO}}</small>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex
                            py-4
                            xs12
                            class="languages">
                            <strong class="member-info__title" id="known_languages_section">{{speakerConstants.LANGUAGES_SPOKEN}}</strong>
                            <v-flex xs12>
                                <span class="member-info__badge" v-for="(language, i) in getSelectedLanguages(speakerProfile.languages)" :key="i" :data-qe-id="`speaker-profile_language-spoken_${language}`">
                                    {{language.languageName}}
                                </span>
                            </v-flex>
                        </v-flex>
                        <v-flex
                            py-4
                            xs12
                            class="referrals">
                            <strong class="member-info__title" id="referrals_section">{{speakerConstants.REFERRALS}}</strong>
                            <span v-for="(referral, i) in speakerProfile.referrals" :data-qe-id="`speaker-profile_referrals_${referral.referralName}`" :key="i">{{referral.referralName}}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex
                    xs12
                    md4
                    pl-5
                    class="contact-info-xs">
                    <v-flex class="contact-info">
                        <h3>{{speakerConstants.MY_CONTACT_INFORMATION}}</h3>
                        <ul>
                            <li v-if="speakerProfile.phone != '' && speakerProfile.phone">
                                <i class="fas fa-phone"></i> <a slot="activator" :href="`tel:${PhoneNumberFormat(speakerProfile.phoneCode, speakerProfile.phone)} ${speakerProfile.primaryPhoneExt ? memberDirectoryPageConstant.label.PHONE_EXTENSION + speakerProfile.primaryPhoneExt: ''}`" data-qe-id="speaker-profile_country-code">+{{speakerProfile.phoneCode}} {{speakerProfile.phone}}</a>
                            </li>
                            <li>
                                <i class="fas fa-envelope"></i> <a @click="launchEmailClient(speakerProfile.email)" data-qe-id="speaker-profile_email-id">{{speakerProfile.email}}</a>
                            </li>
                            <li v-if="speakerProfile.linkedInUrl !== '' && speakerProfile.linkedInUrl">
                                <i class="fab fa-linkedin-in"></i> <a target="_blank" :href="httpsURL(speakerProfile.linkedInUrl)" data-qe-id="speaker-profile_linkedin-id">{{speakerProfile.linkedInUrl}} </a>
                            </li>
                            <li v-if="speakerProfile.webSiteUrl !== '' && speakerProfile.webSiteUrl">
                                <i class="fas fa-link"></i> <a target="_blank" :href="httpsURL(speakerProfile.webSiteUrl)" data-qe-id="speaker-profile_website-link">{{speakerProfile.webSiteUrl}}</a>
                            </li>
                        </ul>
                    </v-flex>
                    <v-flex mt-3 class="topics">
                        <h3>{{speakerConstants.TOPICS}}</h3>
                        <v-flex>
                            <v-expansion-panel expand>
                                <v-expansion-panel-content v-for="(category, i) in selectedTopics" :key="i">
                                    <template v-slot:header>
                                        <div :data-qe-id="`speaker-profile_topic-category_${category.topicName}`">{{category.topicName}}</div>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <span v-for="(childTopic, i) in category.childTopics" :key="i" class="member-info__badge" :data-qe-id="`speaker-profile_topic_${childTopic.topicName}`">{{childTopic.topicName}}</span>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-flex>
                    <v-flex
                        mt-3
                        class="presentations"
                        id="presentation_section">
                        <h3 v-if="speakerProfile.presentationUrl">{{speakerConstants.PRESENTATIONS}}</h3>
                        <v-flex xs12 v-if="speakerProfile.presentationUrl">
                            <video preload="metadata" class="mt-2" width="100%" height="200" controls :src="speakerProfile.presentationUrl">
                            </video>
                        </v-flex>
                        <v-layout
                            row
                            wrap
                            mt-2
                            class="other-presentations"
                            v-if="speakerProfile.otherLinks && speakerProfile.otherLinks.length>0">
                            <h3> {{SpeakerApplicants.OTHER_PRESENTATIONS}}</h3>
                            <v-flex
                                class="other-presentations__links"
                                pr-2
                                v-for="(link, i) in speakerProfile.otherLinks"
                                :key="i">
                                <v-flex>
                                    <i class="fas fa-link"></i> <a class="d-block" :href="httpsURL(link.engagementLink)" target="_blank"> {{link.engagementLink}}</a>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-flex>
            </v-layout>

        </v-layout>
        <v-dialog v-model="moreInfo" content-class="small">
            <v-card class="custom-dailog speaker_info_dialog">
                <v-card-title>
                    {{SpeakerApplicants.MORE_INFORMATION}}
                    <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="confirmToClose()">
                    </i>
                </v-card-title>
                <v-card-text>
                    <v-flex tag="p" v-html="SpeakerApplicants.YPO_EVENTS_INFO"></v-flex>
                    <v-flex text-xs-center class="pa-3">
                        <v-btn
                            class="primary_btn"
                            @click="confirmToClose()"
                            data-qe-id="info_dialog_btn">OK</v-btn>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "@/store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { speakerConstants } from "./ResourceConstants";

    // import { imageErrorFallback } from "../../common/utils/utils";
    import { SpeakerApplicants } from "../Speakers/speakerConstant";
    import { memberDirectoryPageConstant } from "../MemberDirectoryPage/memberDirectoryPage.constants";
    import StatusOverlay from "../StatusOverlay/StatusOverlay";

    export default {
        name: "SpeakerProfile",
        components: { StatusOverlay },
        data: () => ({
            speakerConstants,
            myTopics: [],
            profileObj: {
                id: '',
                type: '',
                approvalStatus: '',
            },
            moreInfo: false,
            SpeakerApplicants,
            memberDirectoryPageConstant,
        }),
        created() {
            //anyone with a valid login can view a speaker profile
            let speakerType = '';
            let speakerStatus = '';
            if (this.isSpeakerView) {
                speakerType = 'member';
                speakerStatus = 'A';
            } else {
                speakerType = sessionStorage.getItem(SpeakerApplicants.SPEAKER_TYPE) === null ? 'member' : sessionStorage.getItem(SpeakerApplicants.SPEAKER_TYPE);
                speakerStatus = sessionStorage.getItem(this.SpeakerApplicants.SPEAKER_STATUS) === null ? 'A' : sessionStorage.getItem(this.SpeakerApplicants.SPEAKER_STATUS);
            }

            if (!this.isSpeakerView) {
                this.profileObj = {
                    Id: this.$route.query.id,
                    Type: speakerType,
                    ApprovalStatus: speakerStatus,
                };
                this.getSpeakerProfile(this.profileObj);
            }
            //calling all of this ahead of time to ease the load when edit id launched
            this.getCountryList();
            this.getMemberAssociationList();
            this.getLanguagesList();
            this.getFeeRangeList();
            this.getCanViewSpeakerAdminDirectory();
        },
        methods: {
            ...mapActions({
                getSpeakerProfile: `speaker/${storeAction.getSpeakerProfile}`,
                getCanViewSpeakerAdminDirectory: `speaker/${storeAction.getCanViewSpeakerAdminDirectory}`,
                authenticateUser: `auth/${storeAction.authenticateUser}`,
                getLanguagesList: `speaker/${storeAction.getLanguagesList}`,
                getCountryList: `speaker/${storeAction.getCountryList}`,
                getFeeRangeList: `speaker/${storeAction.getFeeRangeList}`,
                getMemberAssociationList: `speaker/${storeAction.getMemberAssociationList}`,
            }),
            ...mapMutations({
                setScrollPendingApplicantToViewMember: `speaker/${storeMutation.setScrollPendingApplicantToViewMember}`,
            }),

            PhoneNumberFormat(countryCode, phoneNumber) {
                if (phoneNumber) {
                    if (countryCode && phoneNumber.length >= 3) {
                        return `+${countryCode} ${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, phoneNumber.length)}`;
                    } else if (phoneNumber.length >= 3) {
                        return `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, phoneNumber.length)}`;
                    }
                }
            },

            getSelectedLanguages(languages) {
                return languages && languages.length ? languages.filter(lan => lan.isSelected) : [];
            },
            imageErrorFallback(element) {
                element.profileImageUrl = element.fallbackProfileImageUrl;
                return `this.src='${element.fallbackProfileImageUrl || ''}';this.onerror=null;`;
            },

            viewMySpeakerProfile(speakerType) {
                if (speakerType === "Non-Member") {
                    return false;
                }
                return true;
            },

            openMemberProfile(pMemberId) {
                this.$router.push({
                    path: '/memberProfile',
                    query: {
                        memberId: pMemberId,
                    },
                });
            },
            openEditProfile(speakerProfile) {
                // eslint-disable-next-line no-unused-vars
                const speakerId = speakerProfile.speakerType === this.speakerConstants.NON_MEMBER_SPEAKER_TYPE ?
                    speakerProfile.id :
                    speakerProfile.personId;
                this.$router.push({
                    path: '/speakerPage/editSpeakerProfile',
                    query: {
                        id: this.$route.query.id,
                    },
                });
            },
            launchEmailClient(email) {
                window.location = `mailto:${email}`;
            },
            openMoreInfo() {
                this.moreInfo = true;
            },
            confirmToClose() {
                this.moreInfo = false;
            },

            httpsURL(url) {
                if (!url.includes("http")) {
                    return `http://${url}`;
                }
                return url;
            },
            BackToSpeakerDirectory() {
                this.setScrollPendingApplicantToViewMember(this.$route.query.id);
                if (sessionStorage.getItem(SpeakerApplicants.PREVIOUS_PAGE) === "Pending") {
                    this.$router.push({
                        path: '/speakerPage/speakerAdministration',
                        query: {
                            
                            pendingApplicants: true,
                        },
                    });
                } else if (sessionStorage.getItem(SpeakerApplicants.PREVIOUS_PAGE) === "Reviewed") {
                    this.$router.push({
                        path: '/speakerPage/speakerAdministration',
                        query: {
                            reviewedApplicants: true,
                        },
                    });
                } else if (sessionStorage.getItem(SpeakerApplicants.PREVIOUS_PAGE) === "SearchSpeaker") {
                    const searchFilters = JSON.parse(sessionStorage.getItem(SpeakerApplicants.SEARCH_FILTERS));
                    this.$router.push({
                        path: '/speakerPage/searchSpeakers',
                        query: {
                            ...searchFilters,
                        },
                    });
                }
            },
            getNumberInFormat(fees) {
                return `${this.speakerConstants.USD} ${fees.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
            },
        },

        destroyed() {
            sessionStorage.setItem(SpeakerApplicants.RESOURCE_DIRECTORY_LINK, '');
        },

        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                speakerProfile: `speaker/${storeGetters.speakerProfile}`,
                isSpeakerApproved: `speaker/${storeGetters.isSpeakerApproved}`,
                canViewSpeakerAdminDirectory: `speaker/${storeGetters.canViewSpeakerAdminDirectory}`,
                isSpeakerView: `auth/${storeGetters.isSpeakerView}`,
                currentUserId: `auth/${storeGetters.currentUserId}`,
                reviewedApplicants: `speaker/${storeGetters.reviewedApplicants}`,
                pendingApplicants: `speaker/${storeGetters.pendingApplicants}`,
                speakerRegistrationStatus: `speaker/${storeGetters.speakerRegistrationStatus}`,
            }),
            biographyParagraphs() {
                return this.speakerProfile.biography ? this.speakerProfile.biography.trim().split(/(\r?\n){2,}/g) : '';
            },
            loadingAction() {
                return this.actions[storeAction.getSpeakerProfile];
            },
            selectedTopics() {
                if (this.speakerProfile.topics) {
                    const topics = this.speakerProfile.topics.filter(item => item.childTopics.some(subitem => subitem.isSelected === true))
                        .map((item) => {
                            return { ...item, childTopics: item.childTopics.filter(i => i.isSelected === true) };
                        });
                    return topics;
                }
            },
            canEditSpeakerProfile() {
                return this.currentUserId === this.$route.query.id || this.canViewSpeakerAdminDirectory;
            },
            spokenLanguagesCount() {
                if (this.speakerProfile.languages) {
                    return this.speakerProfile.languages.filter(lang => lang.isSelected === true).length;
                }
            },
            searchResults() {
                return sessionStorage.getItem(SpeakerApplicants.PREVIOUS_PAGE) === "SearchSpeaker";
            },
            checkCFF() {
                return this.$route.query.speakersWhoAre && this.$route.query.speakersWhoAre.includes(this.SpeakerApplicants.IS_CFF_SPEAKER);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-profile--wrapper {
        min-height: 500px;
        padding: 10px 30px;

        @include breakpoint(sm) {
            padding: 10px 15px;
        }

        @include breakpoint(xs) {
            padding: 0;
        }
    }

    .speaker-profile {
        margin-top: 70px;

        &__back-to {
            font-size: 16px;
            font-weight: bold;
            text-decoration: none;
            color: $ypo-cta;
            text-transform: uppercase;
        }

        &__edit-profile-btn {
            background-color: rgba($ypo-blue, 0.05);
            border-radius: 6px 6px 0 0;
            display: inline-block;
            padding: 5px 30px;

            .v-btn {
                background-color: $ypo-gold !important;
            }
        }

        h3 {
            border-radius: 4px 4px 0 0;
            background-color: $ypo-blue;
            box-shadow: 0 0 3px 0 rgba($black, 0.5);
            color: $white;
            padding: 15px 30px;
            font-size: 22px;
            font-weight: 500;
            line-height: 26px;
        }

        .member-info {
            background-color: rgba($ypo-blue, 0.05);
            border-radius: 6px 0 6px 6px;
            padding: 30px;

            &__title {
                color: $ypo-blue;
                font-size: 22px;
                font-weight: 500;
                display: block;
                margin-bottom: 10px;
            }

            p {
                word-wrap: break-word;
            }

            .contact-info {
                ul {
                    margin: 0;
                    padding: 0;
                    list-style-type: none;
                    font-size: 14px;

                    li {
                        padding: 15px 10px 10px 26px;
                        display: flex;
                        align-items: center;

                        a {
                            text-decoration: none;
                            color: $ypo-cta;
                            margin-left: 10px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                        }

                        i {
                            font-size: 24px;
                            color: $ypo-blue;
                            width: 30px;
                            text-align: center;

                            &.fa-linkedin-in {
                                background-color: $ypo-blue;
                                color: $white;
                                border-radius: 50px;
                                height: 30px;
                                font-size: 14px;
                                line-height: 30px;
                            }

                            &.fa-link {
                                transform: rotate(44deg);
                            }
                        }
                    }
                }
            }

            &__badge {
                background-color: $white;
                border: 1px solid $ypo-tile-border;
                border-radius: 18px;
                font-size: 12px;
                color: $ypo-cta;
                margin-right: 5px;
                padding: 1px 15px;
                display: inline-block;
                margin-bottom: 10px;
                cursor: default;
            }

            &__details {
                .profile {
                    max-width: 270px;

                    figure {
                        position: relative;
                        background: rgba($ypo-gray, 0.18);
                        display: flex;
                        justify-content: center;
                        min-height: 250px;

                        .v-img {
                            max-width: 100%;
                            max-height: 100%;
                        }

                        small {
                            position: absolute;
                            background-color: $ypo-dark-green;
                            bottom: 0;
                            font-size: 12px;
                            font-weight: 600;
                            text-transform: uppercase;
                            color: $white;
                            left: 0;
                            width: 100%;
                            text-align: center;
                            padding: 5px;
                        }

                        .v-responsive__sizer {
                            padding-bottom: 0;
                        }

                    }

                    span {
                        border: 1px solid $ypo-cta;
                        color: $ypo-cta;
                        font-size: 12px;
                        text-align: center;
                        padding: 10px;
                        text-transform: uppercase;
                        width: 100%;
                        display: inline-block;
                        border-radius: 3px;
                        margin-top: 3px;
                        font-weight: 600;
                        cursor: pointer;

                        &:hover {
                            background-color: $ypo-cta;
                            color: $white;
                        }
                    }
                }

                .summary {
                    padding-left: 40px;

                    strong {
                        font-size: 24px;
                        color: $ypo-blue;
                        font-weight: 600;
                        display: block;
                        line-height: normal;
                    }

                    small {
                        color: $ypo-dark-background-gray;
                        font-size: 14px;
                        display: block;
                        font-weight: 600;
                        line-height: 15px;
                        margin-top: 5px;
                    }

                    &__fee {
                        margin-top: 50px;

                        strong {
                            color: $ypo-gray-text;
                            font-size: 18px;
                            font-weight: bold;
                        }

                        span {
                            font-weight: 600;
                            line-height: 22px;
                            display: block;

                            em {
                                font-style: normal;
                                font-weight: 500;
                            }

                            i {
                                color: $ypo-cta;
                                margin-left: 5px;
                                cursor: pointer;
                            }
                        }

                        .cff_fee {
                            font-size: 12px;
                            color: $ypo-cta;
                            line-height: inherit;
                            font-weight: 600;
                            cursor: pointer;
                            margin: 0 0 5px 0;
                        }
                    }

                    .label-cff {
                        font-size: 12px;
                        cursor: default;
                        background: $ypo-dark-background-gray;
                        color: $white;
                        font-weight: 500;
                        padding: 4px 11px;
                        line-height: 12px;
                        margin-top: 10px;
                        position: absolute;
                    }
                }

            }

            &__more-info {
                .links {
                    border-bottom: 1px solid $ypo-tile-border;
                    padding: 10px 0;

                    a {
                        color: $ypo-cta;
                        font-family: Noto Sans;
                        font-size: 12px;
                        line-height: 16px;
                        text-decoration: none;
                        margin-right: 50px;
                    }
                }

                .forum-facilitator {
                    background-color: $ypo-blue;
                    border-radius: 16px;
                    padding: 15px;
                    margin-top: 20px;

                    &__title {
                        color: $white;
                        font-size: 18px;

                        .since {
                            padding-left: 40px;
                        }
                    }

                    &__body {
                        background-color: $white;
                        border-radius: 14px;
                        padding: 10px;
                        margin-top: 15px;
                        color: $black;

                        .regions {
                            position: relative;

                            span {
                                display: block;
                                font-size: 18px;
                            }

                            &__rating {
                                background-color: $ypo-tile-border;
                                border-radius: 0 14px 0 0;
                                padding: 10px 20px;
                                max-width: 160px;
                                text-align: center;
                                color: $ypo-blue;
                                position: absolute;
                                right: -10px;
                                top: -10px;

                                span {
                                    font-size: 14px;
                                }

                                strong {
                                    font-size: 18px;
                                }
                            }
                        }

                        .fees-daily-rate {
                            &__header {
                                padding: 5px 0;
                                border-bottom: 1px solid rgba($ypo-tile-border, 0.2);
                            }

                            &__row {
                                padding: 5px 0;

                                &:nth-child(odd) {
                                    background-color: rgba($ypo-tile-border, 0.2);
                                }
                            }
                        }

                        .qualifications {
                            strong {
                                text-transform: uppercase;
                                font-size: 14px;
                            }
                        }
                    }
                }

                .about-me {
                    border-bottom: 1px solid $ypo-tile-border;

                    span {
                        display: block;
                        font-weight: bold;
                    }

                    small {
                        font-size: 14px;
                        line-height: 26px;
                    }

                    &__participates {
                        border-left: 1px solid $ypo-tile-border;
                        padding-left: 40px;
                    }
                }

                .languages {
                    border-bottom: 1px solid $ypo-tile-border;
                }

                .referrals {
                    span {
                        display: block;
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 26px;
                    }
                }
            }

            .presentations {
                h3 {
                    background-color: transparent;
                    color: $ypo-blue;
                    box-shadow: none;
                    padding-left: 0;
                }
            }

            .other-presentations {
                &__links {
                    position: relative;
                    padding-left: 60px;
                    margin-bottom: 20px;
                    width: 100%;

                    i {
                        position: absolute;
                        color: $ypo-blue;
                        transform: rotate(44deg);
                        font-size: 20px;
                        left: 0;
                        top: 1px;
                    }

                    a {
                        color: $ypo-cta;
                        text-decoration: none;
                        font-size: 12px;
                        word-break: break-word;
                        font-weight: 600;
                    }
                }
            }

        }

        // Only for Ipad Pro
        @media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
            margin-top: 110px;
        }

        // Only for Ipad mini
        @media only screen and (min-width: 768px) and (max-height: 1024px) and (-webkit-min-device-pixel-ratio: 1.5) {
            margin-top: 110px;
        }

        @include breakpoint(md) {
            .member-info {
                .contact-info-xs {
                    padding-left: 10px !important;
                }
            }

            h3 {
                font-size: 20px;
            }
        }

        @include breakpoint(sm) {
            .member-info {
                .contact-info-xs {
                    padding-left: 0 !important;
                }

                &__title {
                    font-weight: 600;
                    font-size: 16px;
                }
            }

        }

        @include breakpoint(xs) {
            margin-top: 56px;
            margin-bottom: 80px;

            .member-info {
                padding: 15px;
                margin: 0 10px;

                .contact-info-xs {
                    .topics {
                        margin-top: 30px !important;
                    }
                }

                &__details {
                    flex-wrap: wrap;

                    .profile {
                        max-width: 100%;
                        width: 100%;

                        figure {
                            width: 100%;
                            height: auto;
                        }
                    }

                    .summary {
                        padding-left: 0 !important;
                        margin-top: 30px;
                        text-align: center;

                        &__fee {
                            margin-top: 10px;
                        }
                        .label-cff {
                            position: relative;
                            margin-top: 5px;
                            display: inline-block;
                        }
                    }
                }

                &__more-info {
                    margin-top: 0 !important;

                    .links {
                        display: none;
                    }

                    .about-me {
                        &__participates {
                            padding: 10px 0 0 0;
                            border: none;
                        }
                    }

                    .languages,
                    .referrals {
                        padding: 10px 0 !important;
                    }

                    .forum-facilitator {
                        &__title {
                            font-size: 16px;

                            .since {
                                padding-left: 0;
                            }
                        }

                        &__body {
                            .regions {
                                &__rating {
                                    position: relative;
                                    max-width: inherit;
                                    border-radius: 0;
                                    top: 10px;
                                    right: 0;
                                }

                                span {
                                    font-size: 16px;
                                }
                            }

                            .fees-daily-rate {
                                font-size: 12px;
                            }

                            .qualifications {
                                strong {
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }
            }

            h3 {
                font-size: 16px;
                padding: 5px 15px;
            }

            &__back-to {
                text-align: center;
                background-color: $ypo-dark-background-gray;
                color: $white;
                padding: 7px 15px;
                text-align: justify;
                text-transform: capitalize;
                font-size: 13px;
            }

            &__edit-profile-btn {
                display: block;
                text-align: center;
                padding: 15px 30px 5px;
                margin: 10px 10px 0 10px;

                .v-btn {
                    padding: 10px 20px;
                }
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .speaker-profile {
        .member-info {
            .topics {
                .v-expansion-panel {
                    box-shadow: none;

                    .v-expansion-panel__container {
                        background-color: transparent;
                        border-bottom: 1px solid $ypo-tile-border;
                        border-top: 0;

                        .v-expansion-panel__header {
                            color: $ypo-cta;
                            font-size: 14px;
                            font-weight: bold;
                            padding: 8px 30px;
                            transition: all .3ms ease;

                            .v-icon {
                                font-weight: bold;
                                color: $ypo-blue;
                                font-size: 28px;
                            }

                            &:hover {
                                background-color: rgba($ypo-dark-background-gray, 0.1);
                            }
                        }

                        .v-expansion-panel__body {
                            .v-card {
                                background-color: transparent;
                                padding: 10px 28px 0 28px;

                                .v-card__text {
                                    padding: 0;
                                }
                            }
                        }

                        &.v-expansion-panel__container--active {
                            .v-expansion-panel__header {
                                background-color: rgba($ypo-dark-background-gray, 0.1);
                            }
                        }
                    }
                }

            }

            &__details {
                .profile {
                    figure {
                        .v-responsive__sizer {
                            padding-bottom: 0 !important;
                        }
                    }
                }
            }
        }
    }

    .speaker_info_dialog {
        a {
            text-decoration: none;
            color: $ypo-cta;
            font-weight: 600;
        }
    }
</style>
